/* ==========================================================================
   Virsaay — Video Lookbook reel controls
   Arrow buttons step the scrolling row by one card and disable at either end.
   Swipe and trackpad scrolling work without this file.
   ========================================================================== */

(function () {
  'use strict';

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(section) {
    if (section._vvlBound) return;
    var track = section.querySelector('[data-vvl-track]');
    var prev = section.querySelector('[data-vvl-prev]');
    var next = section.querySelector('[data-vvl-next]');
    if (!track || !prev || !next) return;
    section._vvlBound = true;

    function stepWidth() {
      var card = track.querySelector('.vvl-video-card');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function update() {
      var end = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= end;
    }

    function go(direction) {
      track.scrollBy({ left: direction * stepWidth(), behavior: reducedQuery.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    if (root.matches && root.matches('[data-video-lookbook]')) bind(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-video-lookbook]'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
